"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asBool = exports.State = void 0;
var State;
(function (State) {
    State["CORRECT"] = "correct";
    State["INCORRECT"] = "incorrect";
    State["MISSED"] = "missed";
    State["UNSPECIFIED"] = "unspecified";
    State["UNEXPECTED"] = "unexpected";
})(State = exports.State || (exports.State = {}));
const asBool = (state) => {
    switch (state) {
        case State.CORRECT:
            return true;
        case State.INCORRECT:
            return false;
        case State.UNSPECIFIED:
        case State.UNEXPECTED:
        case State.MISSED: // TODO: it should be rather missing than missed
        default:
            return null;
    }
};
exports.asBool = asBool;
//# sourceMappingURL=State.js.map